module.exports = __webpack_public_path__ + "static/media/dr-boateng-dashen-opticians.f90053c1.jpg";